import { useState } from 'react';
import Button from '../../../components/base/Button';

const faqs = [
  {
    question: 'Was kostet ein Abschleppdienst in Berlin?',
    answer:
      'Die Kosten für einen Abschleppdienst in Berlin hängen vom Einsatzort, Fahrzeugtyp und Umfang des Einsatzes ab. Maßgeblich sind unter anderem Anfahrt, Verladung sowie der gewünschte Zielort des Abtransports. Vor Beginn informieren wir transparent über den voraussichtlichen Ablauf. Die konkrete Abrechnung erfolgt nachvollziehbar und dokumentiert.',
  },
  {
    question: 'Wann darf man Falschparker auf Privatgrund abschleppen lassen?',
    answer:
      'Auf Privatgrund dürfen Fahrzeuge abgeschleppt werden, wenn sie unberechtigt parken oder Einfahrten und Zufahrten blockieren. Voraussetzung ist, dass es sich um eine klar erkennbare private Fläche handelt. Wir unterstützen bei der rechtssicheren Dokumentation und der weiteren Abwicklung des Einsatzes.',
  },
  {
    question: 'Wer zahlt bei Falschparkern?',
    answer:
      'Grundsätzlich trägt der Halter des falsch abgestellten Fahrzeugs die Kosten des Abschleppdienstes. Die Abwicklung kann je nach Situation unterschiedlich erfolgen. Wir dokumentieren den Einsatz nachvollziehbar und informieren über die nächsten Schritte.',
  },
  {
    question: 'Wie schnell ist ein Abschleppdienst erreichbar?',
    answer:
      'Unser Abschleppdienst in Berlin ist 24/7 erreichbar. Die tatsächliche Anfahrtszeit hängt von Verkehr, Einsatzlage und Standort ab. Bereits am Telefon erhalten Sie eine realistische Einschätzung zur aktuellen Situation.',
  },
  {
    question: 'Seid ihr Automobilclub oder unabhängig?',
    answer:
      'Wir sind ein privater und unabhängiger Abschleppdienst in Berlin. Es besteht keine Clubbindung. Die Beauftragung erfolgt direkt zwischen Ihnen und unserem Unternehmen, transparent und ohne Mitgliedssystem.',
  },
  {
    question: 'Wo finde ich eure Datenschutzerklärung?',
    answer:
      'Unsere Datenschutzerklärung finden Sie jederzeit im Footer der Website unter dem Link „Datenschutz“. Dort informieren wir transparent über die Verarbeitung personenbezogener Daten, eingesetzte Dienste sowie Ihre Rechte als betroffene Person.',
  },
  {
    question: 'Wie kann ich meine Cookie-Einwilligung ändern oder widerrufen?',
    answer:
      'Ihre Cookie-Einwilligung können Sie jederzeit über den Footer-Link „Cookie-Einstellungen“ erneut öffnen oder über „Widerruf“ anpassen. Marketing-Technologien wie Google Ads Conversion Tracking werden nur mit Ihrer ausdrücklichen Zustimmung geladen.',
  },
];

export default function SpecialsSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="relative overflow-hidden py-24 md:py-28 bg-[#f8fbff]">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.08),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(96,165,250,0.06),transparent_34%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.75),rgba(255,255,255,0.92))]" />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="mb-10 md:mb-14 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-xl">
            <p
              className="text-[0.72rem] tracking-[0.22em] uppercase mb-3 text-sky-600"
            >
              Fragen &amp; Antworten
            </p>
            <h2
              className="text-3xl md:text-4xl lg:text-[2.6rem] font-semibold mb-0 text-slate-900 leading-tight"
            >
              Häufige Fragen zu AbschleppDirekt24
            </h2>
          </div>
          <p
            className="text-sm md:text-base leading-relaxed max-w-xl text-slate-600"
          >
            Hier finden Sie klare Antworten zu Ablauf, Kosten, Erreichbarkeit und rechtssicherem Abschleppen in Berlin. Ohne das übliche Branchen-Gelaber.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const isActive = activeIndex === index;
            return (
              <div
                key={item.question}
                className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-[0_16px_40px_rgba(15,23,42,0.08)] transition-colors duration-300 hover:border-sky-300"
              >
                <button
                  type="button"
                  onClick={() => handleToggle(index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                >
                  <span
                    className="text-sm md:text-base font-semibold text-slate-900 leading-snug"
                  >
                    {item.question}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-700 text-base transition-all duration-200 ${
                      isActive ? 'rotate-45 border-sky-400/35 bg-sky-400/10 text-sky-300' : ''
                    }`}
                  >
                    +
                  </span>
                </button>
                {isActive && (
                  <div className="border-t border-slate-100 px-5 pb-4 md:px-6 md:pb-5">
                    <p
                      className="text-sm md:text-base leading-relaxed text-slate-600"
                    >
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 md:mt-12">
          <div className="rounded-[1.9rem] bg-white border border-slate-200 px-5 py-5 md:px-6 md:py-6 flex flex-col gap-5 shadow-[0_16px_40px_rgba(15,23,42,0.08)]">
            <p
              className="text-sm md:text-base text-slate-600"
            >
              Noch offene Fragen? Kontaktieren Sie uns direkt telefonisch oder springen Sie zur Kontakt-Sektion.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 w-full md:w-auto">
              <Button
                href="/#kontakt"
                size="lg"
                className="w-full sm:w-auto text-[0.72rem] sm:text-sm md:text-base px-6 sm:px-7 py-3.5 rounded-full tracking-[0.16em] sm:tracking-[0.22em] uppercase bg-slate-900 border border-slate-900 text-white shadow-[0_18px_40px_rgba(15,23,42,0.18)] hover:bg-slate-800 hover:border-slate-800 transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  className="mr-3 h-5 w-5 shrink-0 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                Zum Kontakt
              </Button>
              <Button
                href="tel:+4915235750000"
                size="lg"
                className="w-full sm:w-auto text-[0.72rem] sm:text-sm md:text-base px-6 sm:px-7 py-3.5 rounded-full tracking-[0.16em] sm:tracking-[0.22em] uppercase bg-gradient-to-r from-sky-400 to-blue-600 border border-sky-300/30 !text-white shadow-[0_18px_40px_rgba(37,99,235,0.35)] hover:from-sky-300 hover:to-blue-500 hover:shadow-[0_22px_55px_rgba(37,99,235,0.5)] transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  className="mr-3 h-5 w-5 shrink-0 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.03 9.97a16 16 0 0 0 6 6l1.52-1.26a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92z" />
                </svg>
                Direkt anrufen
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
